export enum ActionType {
  SET_USER = 'SET_USER',
}
